import React from 'react';
import { Search } from '@meindach/ui-kit';
import { useTranslation } from 'react-i18next';
import { trackEvent } from '../../util/trackEvent';
import { useRooferFilters } from '../../hooks/useRooferFilters';

export const RooferSearch = () => {
  const { search, setSearch } = useRooferFilters();
  const { t } = useTranslation('filters');
  return (
    <Search
      placeholder={t('search')}
      value={search}
      onChange={setSearch}
      onBlur={() => trackEvent('filterRoofers', 'search', search)}
    />
  );
};
